import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Ultimate Directory. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <ul className="flex space-x-6">
              {/* <li>
                <a href="/about" className="text-sm text-gray-400 hover:text-red-400">About</a>
              </li> */}
              {/* Temporarily commented out 
              <li>
                <a href="/contact" className="text-sm text-gray-400 hover:text-red-400">Contact</a>
              </li>
              <li>
                <a href="/privacy" className="text-sm text-gray-400 hover:text-red-400">Privacy Policy</a>
              </li>
              */}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
